// extracted by mini-css-extract-plugin
export default {"gdprRequestsPage":"styles_gdprRequestsPage__rwEnV","container":"styles_container__Lof6O","fullWidth":"styles_fullWidth__NNQ33"};